import { useSelector } from 'react-redux'

import { skipToken } from '@reduxjs/toolkit/query'

import { getAuthUserId } from '../../../../data/auth/authSelectors'
import { RTKQueryHook, RTKQueryResultType } from '../../../../data/baseApi'
import { getSelectedClientId } from '../../../../data/lyraTherapy/clientSelectors'
import { useGetClientEpisodesQuery } from '../episodesApi'

export const useEpisodesForSelectedClient: RTKQueryHook<typeof useGetClientEpisodesQuery> = () => {
  const selectedClientId = useSelector(getSelectedClientId)
  const userId = useSelector(getAuthUserId)
  return useGetClientEpisodesQuery(
    selectedClientId ? { patientId: selectedClientId, providerId: userId } : skipToken,
  ) as RTKQueryResultType<typeof useGetClientEpisodesQuery>
}
